// Story mode's end-of-night panel (roadmap 35): what happened that night, and after the last night the ending.
// Drawn into the same dialog as Tonight's result (#tonight), with its look (tonight.css).
export function renderStory(root, m, { doc, close, next, again, share }) {
  const el = (tag, cls, text) => {
    const e = doc.createElement(tag);
    if (cls) e.className = cls;
    if (text) { const t = doc.createElement('span'); t.className = 't'; t.textContent = text; e.append(t); e.label = t; }
    return e;
  };
  const title = el('h2', 'tn-title');
  title.append(el('span', 'plate', `Night ${m.night} of ${m.of}`));
  const name = el('p', 'tn-fooled', m.title);
  const squares = el('p', 'tn-squares');
  squares.setAttribute('aria-label', m.results.map(r => (r ? 'right' : 'wrong')).join(', '));
  for (const r of m.results) squares.append(el('span', r ? 'sq right' : 'sq wrong', r ? '■' : '□'));
  const lines = el('ul', 'tn-doors');
  for (const l of m.lines) lines.append(el('li', '', l));
  const parts = [title, name, squares, lines];
  if (m.ending) parts.push(el('p', 'tn-score', m.ending.title), el('p', 'tn-note', m.ending.text)); // the ending is the big line
  const actions = el('div', 'tn-actions');
  const go = el('button', 'btn', m.next ? `Night ${m.night + 1}` : 'Play the week again'), done = el('button', 'btn', 'Close'), out = el('button', 'btn', 'Share');
  go.type = done.type = out.type = 'button';
  go.onclick = () => (m.next ? next() : again());
  done.onclick = () => close();
  out.onclick = async () => { out.label.textContent = (await share(storyShareLine(m))) ? 'Shared' : 'Copy failed'; };
  actions.append(go, out, done);
  parts.push(actions);
  const card = el('div', 'tn-card');
  card.append(...parts);
  root.replaceChildren(card);
  return { go, done };
}

// /?story=1 opens the story as soon as the start screen is up
export const wantsStory = search => new URLSearchParams(search).get('story') === '1';

// The story's neighbours keep a face of their own (game/story.js gives each a face id). The traits are client/visitors.js
// makeLook's (height: a higher number stands lower, so shorter), laid over the seed's look; a visitor using a neighbour's name wears the same face, so the face never tells.
export const STORY_LOOKS = {
  'story-mira': { hairStyle: 'ponytail', scarf: true, glasses: false, beard: false, mustache: false, headW: 10, headH: 12, bodyW: 21, height: 0, expression: 'tired' },
  'story-mr haddad': { hairStyle: 'hat', scarf: false, glasses: true, beard: true, mustache: true, headW: 10, headH: 12, bodyW: 22, height: 2, expression: 'worried' },
  'story-jonas': { hairStyle: 'beanie', scarf: false, glasses: false, beard: false, mustache: false, headW: 9, headH: 12, bodyW: 21, height: -3, expression: 'smirk' },
  'story-nell': { hairStyle: 'bun', scarf: false, glasses: false, beard: false, mustache: false, headW: 9, headH: 12, bodyW: 20, height: 0, expression: 'tired' },
  'story-petra': { hairStyle: 'bob', scarf: false, glasses: false, beard: false, mustache: false, earrings: true, headW: 9, headH: 11, bodyW: 22, height: -1, expression: 'worried' },
  'story-wim': { hairStyle: 'cap', scarf: false, glasses: false, beard: true, mustache: false, headW: 11, headH: 12, bodyW: 24, height: -1, expression: 'smile' },
  'story-lotte': { hairStyle: 'long', scarf: true, glasses: false, beard: false, mustache: false, headW: 9, headH: 13, bodyW: 20, height: 0, expression: 'neutral' },
  'story-kofi': { hairStyle: 'short', scarf: false, glasses: false, beard: false, mustache: false, headW: 10, headH: 12, bodyW: 23, height: -2, expression: 'worried' },
};

// The share line: the night or the ending, the squares and the score, and a link that opens the story. No names, no lines.
export function storyShareLine(m, origin = globalThis.location?.origin ?? '') {
  const right = m.results.filter(Boolean).length;
  const head = m.ending ? `KNOCK, The first week: ${m.ending.title}.` : `KNOCK, The first week, night ${m.night}: ${m.title}.`;
  const score = m.ending ? m.week : m.score;
  return `${head} ${m.results.map(r => (r ? '\u{1F7E9}' : '\u{1F7E5}')).join('')} ${right}/${m.results.length}${score !== undefined ? `, ${score} points` : ''} ${origin}/?story=1`;
}
